export const requireEnv = (name: string): string => {
  const value = process.env[name];

  if (!value) {
    throw new Error(
      `Missing required environment variable "${name}". Contentstack credentials must be ` +
        `provided via the environment (SSM/Consul in deployed environments, .env locally).`,
    );
  }

  return value;
};
